import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { DealersListContext } from '../DealersListContext';
import { productLineLabelMap } from '../../utils/constants';
import getRadioBtnGroupDefaultValue from './utils/getRadioBtnGroupDefaultValue';

const ProductLinesRadioGroup = ({ productLines }) => {
  const { t } = useTranslation();
  const { productLinesSelection, setProductLineCode, setProductLinesSelection } = useContext(DealersListContext);

  const radioGroupOptions = productLines.map(productLine => ({
    text: t(`Sub-apps.Dealers.${productLineLabelMap.get(productLine)}`),
    value: productLine,
  }));
  const defaultValue = getRadioBtnGroupDefaultValue(productLines[0], productLinesSelection);

  const handleOnChange = event => {
    const selectedProductLine = event?.target?.value;
    if (!selectedProductLine) return;
    const productLinesUpdate = productLines.reduce((acc, productLine) => {
      acc[productLine] = productLine === selectedProductLine;
      return acc;
    }, {});
    setProductLinesSelection(productLinesUpdate);
    setProductLineCode(selectedProductLine);
  };

  return (
    <RadioGroup
      name="product-lines-selector"
      defaultValue={defaultValue}
      direction="row"
      options={radioGroupOptions}
      onChangeCallback={handleOnChange}
      data-testid="cy-product-lines-radio-group"
      mt="m"
      mb={['default', 'l']}
      styling="variant1"
      radioGroupItemStyles={{ mr: 'm' }}
    />
  );
};

ProductLinesRadioGroup.propTypes = {
  productLines: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProductLinesRadioGroup;
